import { render, staticRenderFns } from "./OperationPartListSuspendedContainer.vue?vue&type=template&id=2735dfc4&scoped=true"
import script from "./OperationPartListSuspendedContainer.vue?vue&type=script&lang=js"
export * from "./OperationPartListSuspendedContainer.vue?vue&type=script&lang=js"
import style0 from "./OperationPartListSuspendedContainer.vue?vue&type=style&index=0&id=2735dfc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735dfc4",
  null
  
)

export default component.exports